import { showAppAlert } from '../utils/alertService';
import React, { useState } from 'react';
import '../styles/formStyles.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function AddPromotionModal({ visible, onClose, onAdd }) {
  const [formData, setFormData] = useState({
    nome: '',
    descricao: '',
    data_inicio: '',
    data_termino: '',
    pontos: '',
  });
  
  const [dateError, setDateError] = useState('');

  if (!visible) return null;

  const validateDates = (startDate, endDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const start = new Date(startDate + 'T00:00:00');
    const end = new Date(endDate + 'T00:00:00');
    
    if (start.getTime() < today.getTime()) {
      setDateError('A data de início não pode ser anterior à data atual');
      return false;
    }
    
    if (endDate && startDate && end < start) {
      setDateError('A data de término não pode ser anterior à data de início');
      return false;
    }
    
    setDateError('');
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (name === 'data_inicio' || name === 'data_termino') {
      const startDate = name === 'data_inicio' ? value : formData.data_inicio;
      const endDate = name === 'data_termino' ? value : formData.data_termino;
      
      if (startDate && endDate) {
        validateDates(startDate, endDate);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (!validateDates(formData.data_inicio, formData.data_termino)) {
      return;
    }

    const companyId = localStorage.getItem('company_id');
    const token = localStorage.getItem('token');

    const newPromotion = {
      nome: formData.nome,
      descricao: formData.descricao,
      pontos: formData.pontos,
      data_inicio: formData.data_inicio,
      data_termino: formData.data_termino,
      company_id: companyId,
    };

    try {
      const response = await fetch(`${API_URL}/promotions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newPromotion),
      });

      if (response.status === 201) {
        const createdPromotion = await response.json();
        showAppAlert('success', 'Promoção adicionada com sucesso!');
        onAdd(createdPromotion); // Apenas notifica o componente pai para recarregar
      } else {
        const errorData = await response.json();
        showAppAlert('error', `Erro ao adicionar promoção: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Erro ao adicionar promoção:', error);
      showAppAlert('error', `Erro ao adicionar promoção: ${error.message}`);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 style={{ 
          borderBottom: '2px solid #C8A2C8', 
          paddingBottom: '5px',
          fontSize: 'clamp(1.2rem, 2vw, 1.5rem)' 
        }}>Adicionar Promoção</h3>
        <form onSubmit={handleSubmit}>
          <div className="label-style">
            <label>Nome:</label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              className="input-style"
              required
            />
          </div>
          <div className="label-style">
            <label>Descrição:</label>
            <textarea
              name="descricao"
              value={formData.descricao}
              onChange={handleChange}
              className="input-style"
              required
            />
          </div>
          <div className="form-row">
            <div className="label-style flex-1">
              <label>Data de Início:</label>
              <DatePicker
                selected={formData.data_inicio ? new Date(formData.data_inicio + 'T00:00:00') : null}
                onChange={(date) => handleChange({ target: { name: 'data_inicio', value: date.toISOString().split('T')[0] } })}
                className="input-style"
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/aaaa"
                minDate={new Date()}
                showYearDropdown
                scrollableYearDropdown
                required
              />
            </div>
            <div className="label-style flex-1">
              <label>Data de Término:</label>
              <DatePicker
                selected={formData.data_termino ? new Date(formData.data_termino + 'T00:00:00') : null}
                onChange={(date) => handleChange({ target: { name: 'data_termino', value: date.toISOString().split('T')[0] } })}
                className="input-style"
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/aaaa"
                showYearDropdown
                scrollableYearDropdown
                minDate={formData.data_inicio ? new Date(formData.data_inicio + 'T00:00:00') : new Date()}
                required
              />
            </div>
          </div>
          {dateError && <p className="error-message">{dateError}</p>}
          <div className="label-style">
            <label>Pontos:</label>
            <input
              type="number"
              name="pontos"
              value={formData.pontos}
              onChange={handleChange}
              className="input-style"
              required
            />
          </div>
          <div className="button-container">
            <button type="submit" className="button-style">Adicionar</button>
            <button type="button" onClick={onClose} className="button-style cancel">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddPromotionModal;
